export default __webpack_public_path__ + "static/media/manageBulkUpload.56a10762.svg";